import { ecoSettingService } from "client-app-core";
import * as t from "./actionTypes";

const ecoSettingsReceived = (data) => {
    return {
        type: t.ECO_SETTINGS_RECEIVED,
        payload: data
    };
};

export const getEcoSettings = () => {
    return (dispatch) => {
        ecoSettingService.getAll((err, res) => {
            if (err) {
                console.log("Eco Settings Service error received", err);
            } else {
                dispatch(ecoSettingsReceived(res));
            }
        });
    };
};
